import React from 'react'
import { ArrowLeft, Info } from 'react-feather';
import Select from "react-select";
import { ControlledInput } from '../../common/Input/Input';

const AddExpenses = (props) => {
  return (
      <div>
          <span style={{ cursor: "pointer" }} onClick={props.onBackClick}>
              <ArrowLeft style={{ marginRight: "10px" }} />
          </span>
          <label>
              <b>Add Expenses</b>
          </label>

          <div className='mt-2' style={{
            color: '#76287C'
          }}>
          <label>
              <b>Time Period</b>
          </label>
          </div>

          <div className="row">
          <div className="col-3">
                    <label style={{ marginBottom: "10px" }}>Month<span className="required">*</span> </label><br />
                    <Select
                        className="w-100"
                        options={props.monthOptions}
                        onChange={props.onMonthChange}
                        value={props.selectedMonth}
                    />
                </div>

                <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>Year<span className="required">*</span></label><br />
                  {/* <ControlledInput
                      className="w-100"
                      name="nYear"
                      placeholder="eg. 2024"
                      value={props.expenseFields.nYear}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      autoComplete="off"
                  /> */}
                  <Select
                        className="w-100"
                        options={props.yearOptions}
                        onChange={props.onYearChange}
                        value={props.selectedYear}
                    />
              </div>
          </div>

          <div className='mt-3' style={{
            color: '#76287C'
          }}>
          <label>
              <b>Staff Expenses</b>
          </label>
          </div>

          <div className="row">
              <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>Program Director</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sPrg_Director"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sPrg_Director}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>

              <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>Program Manager</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sPrg_Mngr"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sPrg_Mngr}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>

              <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>Program Executive</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sPrg_Exe"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sPrg_Exe}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>
          </div>

          <div className='' style={{
            color: '#76287C'
          }}>
          <label>
              <b>Programme Expense</b>
          </label>
          </div>

          <div className="row">
          <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>Mobilization and Communication</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sMobilization_Communication"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sMobilization_Communication}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>

              <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>Group Knowledge Session</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sGroup_Knowledge_Session"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sGroup_Knowledge_Session}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>

              <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>Group Expert Consultation</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sGroup_Expert_Consultation"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sGroup_Expert_Consultation}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>

              <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>Access to Market</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sAccess_to_Market"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sAccess_to_Market}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>
          </div>

          <div className="row">
          <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>Access to Compliance</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sAccess_to_Compliance"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sAccess_to_Compliance}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>

              <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>Access to Finance - BLRP</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sAccess_to_Finance_BLRP"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sAccess_to_Finance_BLRP}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>

              <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>Travel Expense</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sTravel_Expenses"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sTravel_Expenses}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>

              <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>Equipment and Supplies</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sEquipment_Supplies"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sEquipment_Supplies}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>
          </div>

          <div className='' style={{
            color: '#76287C'
          }}>
          <label>
              <b>Contract Services</b>
          </label>
          </div>

          <div className="row">
          <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>deAsra Portal</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sDeAsra_Portal"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sDeAsra_Portal}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>

              <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>deAsra Dashboard - Convenio</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sDeAsra_Dashboard_Convenio"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sDeAsra_Dashboard_Convenio}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>
          </div>

          <div className='' style={{
            color: '#76287C'
          }}>
          <label>
              <b>Marketing and Promotion Expenses</b>
          </label>
          </div>

          <div className="row">
          <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>Upgrowth</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sUpgrowth"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sUpgrowth}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>
          </div>

          <div className='' style={{
            color: '#76287C'
          }}>
          <label>
              <b>External Evaluation</b>
          </label>
          </div>

          <div className="row">
          <div className="col-3">
                  <label style={{ marginBottom: "10px" }}>GIPE / CEED - Research Expense</label><br />
                  <ControlledInput
                      className="w-100"
                      name="sGIPE_CEED_Research_Expense"
                      placeholder="eg. 20000"
                      value={props.expenseFields.sGIPE_CEED_Research_Expense}
                      onChange={({ target: { name, value } }) => props.handleChange(name, value)}
                      onKeyDown={(e) => {
                          const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "."];
                          if (
                              !/^\d$/.test(e.key) &&
                              !allowedKeys.includes(e.key) &&
                              e.key !== "Tab"
                          ) {
                              e.preventDefault();
                          }
                      }}
                      onInput={(e) => {
                        const { value } = e.target;
                        const match = value.match(/^(\d+(\.\d{0,2})?)$/);
                        if (!match) {
                          e.target.value = value.slice(0, -1);
                        }
                      }}
                      autoComplete="off"
                  />
              </div>
          </div>

          <div className="row mt-3">
                <div className="col">
                    <button className='my-services-model-submit-btn' onClick={props.onSaveClick}> Save</button>
                </div>
            </div>
      </div>
  )
}

export default AddExpenses
